import { styled } from '@mui/material';
import { ChipPropsColorOverrides } from '@mui/material/Chip/Chip';
import { OverridableStringUnion } from '@mui/types';

interface InvertedRadioProps {
    boxShadowColors?: [string, string];
    thick?: boolean;
}

const InvertedRadio = styled('span')<InvertedRadioProps>(
    ({ theme, boxShadowColors = ['rgba(16,22,26,.2)', 'rgba(16,22,26,.1)'], thick = false }) => ({
        borderRadius: '50%',
        width: 20,
        height: 20,
        boxShadow: `inset 0 0 0 ${thick ? 2 : 1}px ${boxShadowColors[0]}, inset 0 -${thick ? 2 : 1}px 0 ${
            boxShadowColors[1]
        }`,
        backgroundColor: theme.palette.white.main,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '.Mui-focusVisible &': {
            outline: `2px auto ${theme.palette.primary.main}`,
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: theme.palette.white.main,
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: theme.palette.disabled.main,
        },
    })
);

interface InvertedRadioCheckedProps {
    color?: OverridableStringUnion<
        'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning',
        ChipPropsColorOverrides
    >;
}

const InvertedRadioChecked = styled(InvertedRadio)<InvertedRadioCheckedProps>(({ theme, color = 'primary' }) => ({
    backgroundColor: theme.palette[color].main,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    boxShadow: 'none',
    '&::before': {
        display: 'block',
        width: 20,
        height: 20,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette[color].dark,
    },
}));

export { InvertedRadio, InvertedRadioChecked };
